import { Flex, Typography } from '@/shared/antd-imports';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '@/hooks/useAppSelector';
import { PORTAL_NAME, brandLogoFor } from '@/config/brand';

type AuthPageHeaderProp = {
  description: string;
};

// This page header is used only in auth pages for client portal
const AuthPageHeader = ({ description }: AuthPageHeaderProp) => {
  const { t } = useTranslation();
  const currentTheme = useAppSelector((state) => state.ui.theme);

  return (
    <Flex vertical align="center" gap={8} style={{ marginBottom: 24 }}>
      <img
        src={brandLogoFor(currentTheme)}
        alt={t('app.brandAttribution.logoAlt', {
          defaultValue: '{{portal}} logo',
          portal: PORTAL_NAME,
        })}
        style={{ width: '100%', maxWidth: 180, marginBottom: 8 }}
      />
      <Typography.Title level={2} style={{
        color: currentTheme === 'dark' ? '#ffffff' : '#000000',
        margin: 0
      }}>
        {t('app.title', { defaultValue: 'Client Portal' })}
      </Typography.Title>
      <Typography.Text style={{
        color: '#8c8c8c',
        maxWidth: 400,
        textAlign: 'center'
      }}>
        {description}
      </Typography.Text>
    </Flex>
  );
};

export default AuthPageHeader;
